// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const AcceptIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 15.9899L13.3072 21L24 9" stroke={iconColor} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default AcceptIcon;
